// extracted by mini-css-extract-plugin
export default {"button":"button-qFpK53MU0KFxkFG_myXD"};